<template>
  <div class="uploader-box">
    <el-upload
      :accept="accept"
      :action="uploadConfig.url"
      :multiple="multiple"
      :on-success="uploadSuccess"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :show-file-list="false"
      :limit="limit"
      :on-exceed="exceedHandle"
      :on-error="errorHandle"
    >
      <slot name="btn">
        <div class="file-box" >
          <i class="el-icon-plus btn-upload"></i>
        </div>
      </slot>
    </el-upload>
    <viewer class="list-box" :images="fileData" ref="viewer" @inited="inited" v-if="showPreview">
      <template #default="scope">
        <div class="file-box" v-for="(file, index) in fileData" :key="index">
          <img :src="file" class="img"/>
          <div class="opt-box">
            <i class="el-icon-delete" @click="del(index)"></i>
            <i class="el-icon-zoom-in" @click="show"></i>
          </div>
        </div>
      </template>
    </viewer>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  name: "MultipleImageUpload",
  props: {
    value: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: "image/*",
    },
    limit: {
      type: Number,
      default: null,
    },
    showTips: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: "#FFF",
    },
    fileType: {
      type: String,
      default: "img",
    },
    showPreview:{
      type:Boolean,
      default:true
    }
  },
  computed: {
    fileData: {
      get() {
        if(!this.value){
          return []
        }
        let tmp=[]
        try{
          tmp=JSON.parse(this.value)
        }catch(e){
          console.error(`MultipleImageUpload fileData`,e)
        }
        if(!tmp){
          return []
        }
        return tmp;
      },
      set(newVal) {
        let data=newVal
        if(newVal){
          data=JSON.stringify(newVal)
        }
        this.$emit("input", data);
      },
    },
  },
  data() {
    return {
      uploadConfig: {
        url: "",
      },
      uploading: false,
    };
  },
  created() {
    this.uploadConfig.url = `${
      window.SITE_CONFIG["apiURL"]
    }/sys/oss/upload?token=${Cookies.get("token")}`;
  },
  methods: {
    show() {
      this.$viewer.show();
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    refresh(newVal) {
      this.fileData = newVal;
    },
    del(index) {
      let tmp=this.fileData
      if (tmp === 1) {
        tmp = [];
      } else {
        tmp.splice(index, 1);
      }
      this.fileData=tmp
    },
    forward(index) {
      if (index < 1) {
        return;
      }
      let t1 = this.fileData[index];
      let t2 = this.fileData[index - 1];
      this.fileData[index - 1] = t1;
      this.fileData[index] = t2;
      this.$forceUpdate();
    },
    back(index) {
      if (index > this.fileData.length - 2) {
        return;
      }
      let t1 = this.fileData[index];
      let t2 = this.fileData[index + 1];
      this.fileData[index + 1] = t1;
      this.fileData[index] = t2;
      this.$forceUpdate();
    },
    reset() {
      this.fileData = [];
    },
    beforeUpload(file) {
      return true;
    },
    uploadSuccess(res, file, fileList) {
      if (res.code !== 0) {
        this.$message.error(res.msg);
        return;
      }
      let tmp=this.fileData
      tmp.push(res.data.src);
      this.fileData=tmp
    },
    errorHandle(err, file, fileList) {
      this.uploading = false;
      this.$message.error("上传失败");
    },
    exceedHandle(files, fileList) {
      this.uploading = false;
      this.$message.error(`最多只能上传${this.limit}个`);
    },
    handleRemove() {},
  },
};
</script>

<style lang="scss" scoped>
.uploader-box{
  display: flex;
  .btn-upload{
    font-size: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: dashed 1px #f7f7f7;
    width: 100px;
    height: 100px;
  }
  .list-box {
    display: flex;
    flex-wrap: wrap;
    margin-right: -10px;
    height: calc(100% - 60px);
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
  }
}
.file-box:hover {
  .opt-box {
    display: flex;
  }
}

.file-box {
  border: solid 1px #c0c4cc;
  border-radius: 10px;
  overflow: hidden;
  width: 100px;
  height: 100px;
  margin: 0 10px 10px 0;
  position: relative;
  .opt-box {
    cursor: pointer;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.3);
    display: none;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    color: #fff;
    font-size: 28px;
    i {
      margin: 0 4px 0 4px;
      cursor: pointer;
    }
  }
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .label {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    height: 30px;
    background-color: rgba($color: #000000, $alpha: 0.5);
    cursor: pointer;
  }
}
</style>
